import React from "react";
import Leftimage from "../assets/images/Weddingleft.png";
import Navbar from "../components/Navbar";
import { useState, useEffect } from "react";
import BannerFamily from "../components/BannerFamily";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import RiverCruisePreperation from "../components/RiverCruisePreperation";
import RiverCruiseTheme from "../components/RiverCruiseTheme";
import RiverBanner from "../components/RiverBanner";
import { fetchData } from "../services/api";
import { Helmet } from "react-helmet";
// Interfaces
interface PlanningTripData {
  text: string;
  description: string;
}

interface bannersData {
  bannerText: string;
  subText: string;
  bannerVideo: string;
}

interface MetaData {
  metaKeyword: string;
  metaDescription: string;
  metaTitle: string;
}

const RiverCruise: React.FC = () => {
  const [planningTripData, setPlanningTripData] = useState<PlanningTripData>({
    text: "",
    description: "",
  });

  const [metaData, setMetaData] = useState<MetaData>({
    metaKeyword: "",
    metaDescription: "",
    metaTitle: "",
  });

  const [bannerData, setBannerData] = useState<bannersData>({
    bannerText: "",
    subText: "",
    bannerVideo: "",
  });

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await fetchData<{
          meta_title: string;
          meta_keyword: string;
          meta_description: string;
          whereTo: PlanningTripData[];
          banners: bannersData[];
        }>({
          url: "pages/get",
          data: { pageId: 9 },
        });

        const data = response?.data;

        if (data) {
          // Set meta tags
          setMetaData({
            metaTitle: data.meta_title,
            metaKeyword: data.meta_keyword,
            metaDescription: data.meta_description,
          });

          // Set PlanningTrip data
          if (data.whereTo?.length > 0) {
            setPlanningTripData(data.whereTo[0]);
          }

          // Set banner data
          if (data.banners?.length > 0) {
            setBannerData(data.banners[0]);
          }
        } else {
          throw new Error("No data found.");
        }
      } catch (error) {
        console.error("Failed to fetch page data:", error);
        setError("Failed to load page data.");
      }
    };

    fetchPageData();
  }, []);
  return (
    <div>
      <Helmet>
        <title>{metaData.metaTitle}</title>
        <meta name="title" content={metaData.metaTitle} />
        <meta name="keywords" content={metaData.metaKeyword} />
        <meta name="description" content={metaData.metaDescription} />
        <link rel="canonical" href="https://travelnrelax.com/river-cruise/" />
      </Helmet>
      {bannerData.bannerText && (
        <Navbar
          heading={bannerData.bannerText}
          subHeading={bannerData.subText}
          video={bannerData.bannerVideo}
        />
      )}
      <RiverCruiseTheme />
      <RiverBanner />
      <RiverCruisePreperation />
      <PlanningTrip
        headingplanning={
          planningTripData.text || "Start Planning Your Group Adventure"
        }
        paragraph={
          planningTripData.description ||
          "Let us take care of the details while you enjoy quality time with your group."
        }
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default RiverCruise;
